import i18n from 'i18next';
import Backend from 'i18next-http-backend';
// import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en_HK from './locales/en_HK.json';
import zh_HK from './locales/zh_HK.json';
import zh_CN from './locales/zh_CN.json';

const resources = {
  'en-HK': {
      translation: en_HK
  },
  'zh-HK': {
      translation: zh_HK
  },
  'zh-CN': {
      translation: zh_CN
  }
};
let lang: string;
if (window.location.pathname.includes('/chi')){
  lang = 'zh-HK';
} else if(window.location.pathname.includes('/schi')){
  lang = 'zh-CN';
} else {
  lang = 'en-HK';
} 
console.log()

i18n
  .use(Backend)
  // .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    resources,

    lng: lang,
    fallbackLng: 'en-HK',
    debug: true,

    interpolation: {
      escapeValue: false, // not needed for react!!
    },

    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    react: {
      // bindI18n: 'languageChanged',
      // bindI18nStore: '',
      // transEmptyNodeValue: '',
      // transSupportBasicHtmlNodes: true,
      // transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    }
  });

  // i18n.on('languageChanged', (lng) => {
  //   document.documentElement.lang = lng;
  //   document.title = i18n.t('htmlTitle');
  // });
  document.title = i18n.t('htmlTitle');
  document.documentElement.lang = lang;

export default i18n;